module.exports = __webpack_public_path__ + "img/icon-close-gray.fdc21cba.svg";